export const breakpointS = 1020 as const
export const breakpointM = 1440 as const
export const breakpointL = 2550 as const

export const breakpoints = {
  s: breakpointS,
  m: breakpointM,
  l: breakpointL,
} as const

export const mediaBreakpoints = {
  s: `@media screen and (max-width: ${breakpointS}px)`,
  m: `@media screen and (max-width: ${breakpointM}px)`,
  l: `@media screen and (max-width: ${breakpointL}px)`,
} as const

export const viewWidthSizeSlim = 1024 as const
export const viewWidthSizeRegular = 1600 as const
export const viewWidthSizeWide = 1920 as const
export const viewWidthSizeUltraWide = 2560 as const

export const viewWidthSizes = {
  slim: viewWidthSizeSlim,
  regular: viewWidthSizeRegular,
  wide: viewWidthSizeWide,
  'ultra-wide': viewWidthSizeUltraWide,
} as const
